import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

const COUPLE_PHOTO =
  "https://customer-assets.emergentagent.com/job_ceremonial-bliss-2/artifacts/z4hayloz_WhatsApp%20Image%202026-06-26%20at%2012.23.38.jpeg";

const PhotoSection = () => {
  const { lang } = useLang();
  const caption = "Marcel & Aida";
  const sub =
    lang === "ro"
      ? "Ce e mai bun urmează."
      : "Lo mejor está por venir.";

  return (
    <section
      data-testid="photo-section"
      className="py-20 md:py-28 px-6 relative"
    >
      <div className="max-w-md mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          {/* Decorative double gold frame */}
          <div className="absolute -inset-3 md:-inset-4 border border-gold/40 rounded-[24px] pointer-events-none" />
          <div className="absolute -inset-1.5 md:-inset-2 border border-wine/15 rounded-[20px] pointer-events-none" />

          {/* Full image visible — no harsh cropping */}
          <div className="relative rounded-[16px] overflow-hidden shadow-[0_18px_50px_rgba(107,45,49,0.18)] bg-cream">
            <img
              src={COUPLE_PHOTO}
              alt="Marcel &amp; Aida"
              className="block w-full h-auto"
              data-testid="couple-photo"
              loading="lazy"
            />
            {/* Soft warm overlay to harmonize with palette */}
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-cream/25 via-transparent to-transparent" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="text-center mt-10"
        >
          <span className="divider-gold">
            <span className="font-editorial italic text-base md:text-lg text-olive">
              {sub}
            </span>
          </span>
        </motion.div>
      </div>
    </section>
  );
};

export default PhotoSection;
